import { SET_VALUE } from './types';

export function setValueAction(value) {
  return {
    type: SET_VALUE,
    payload: value,
  };
}


// WEBPACK FOOTER //
// ./demo/src/actions/test-values.js